import { asset_url } from './config';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { t } from 'i18next';

dayjs.extend(advancedFormat);
export const _validateNumber = (event, allowFloat) => {
  let key;
  if (event.type === 'paste') {
    key = event.clipboardData.getData('text/plain');
  } else {
    key = event.keyCode || event.which;
    key = String.fromCharCode(key);
  }
  let regex = /^\d+$/;

  if (!regex.test(key)) {
    if (allowFloat) {
      if (key !== '.') {
        event.returnValue = false;
        if (event.preventDefault) event.preventDefault();
      }
    } else {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
  }
};

export const _fetchFile = async url => {
  if (!navigator.onLine) {
    return new File([''], `image-${Math.random()}.png`);
  }
  let proxyUrls = [
    'https://omnicors.herokuapp.com/',
    'https://cors-anywhere.herokuapp.com/',
  ];
  let proxyIndex = 0;
  let response = await fetch(`${proxyUrls[proxyIndex]}${url}`);
  if (response.ok) {
    let blob = await response.blob();
    let file = new File([blob], `image-${Math.random()}.png`);
    return file;
  } else {
    if (proxyIndex < proxyUrls.length) {
      proxyIndex = proxyIndex + 1;
      _fetchFile(url);
    } else {
      return new File([''], `image-${Math.random()}.png`);
    }
  }
};

export const _removeStringSpace = string => {
  return string ? string.replace(/ /g, '') : '';
};

export const _validatePhoneNumber = phoneNumber => {
  let maxLength = t('phone.maxLength');
  let minLength = t('phone.minLength');

  if (phoneNumber) {
    if (/^\d+$/.test(phoneNumber)) {
      phoneNumber = phoneNumber.toString();
      if (Number(phoneNumber.substring(0, 1)) === 0) {
        if (
          phoneNumber.length !== 0 &&
          (phoneNumber.length > maxLength || phoneNumber.length < minLength)
        ) {
          return `Phone numbers should have a ${
            phoneNumber.length > maxLength
              ? `maximum of ${maxLength}`
              : `minimum of ${maxLength}`
          } numbers`;
        } else {
          return '';
        }
      } else {
        return `Phone numbers should start with 0`;
      }
    } else {
      return `Invalid phone number`;
    }
  } else {
    return '';
  }
};

export const _findArray = (array, id, param) => {
  return array.find(el => {
    return (
      (el[id]
        ? typeof el[id] !== 'string'
          ? el[id]
          : el[id].toLowerCase().replace(/ /g, '')
        : el[id]) ===
      (param
        ? typeof param !== 'string'
          ? param
          : param.toLowerCase().replace(/ /g, '')
        : param)
    );
  });
};

export const _groupArray = (array, field) => {
  return array.reduce(function (h, obj) {
    h[obj[field]] = (h[obj[field]] || []).concat(obj);
    return h;
  }, {});
};

export const _postToLocalStorage = (field, value) => {
  try {
    localStorage.setItem(field, JSON.stringify(value));
  } catch (error) {}
};

export const _getFromLocalStorage = field => {
  try {
    return JSON.parse(localStorage.getItem(field));
  } catch (error) {
    return '';
  }
};

export const _getStockPointParams = (stockPointId, subOrderId) => {
  switch (true) {
    case stockPointId > 0 && subOrderId > 0:
      return `&StockPointId=${stockPointId}&SubOrderId=${subOrderId}`;
    case stockPointId > 0:
      return `&StockPointId=${stockPointId}`;
    case subOrderId > 0:
      return `&SubOrderId=${subOrderId}`;
    default:
      return '';
  }
};

// export const _formatCurrency = amount => {
//   try {
//     if (amount || amount === 0) {
//       let formatedAmount = new Intl.NumberFormat(
//         `en-${
//           _getFromLocalStorage('selectedCountryDetails').currency
//             ? _getFromLocalStorage('selectedCountryDetails').currency
//             : 'NH'
//         }`,
//         {
//           style: 'currency',
//           currency: `${
//             _getFromLocalStorage('selectedCountryDetails').currencyCode
//               ? _getFromLocalStorage('selectedCountryDetails').currencyCode
//               : 'NGN'
//           }`,
//           minimumFractionDigits: 0,
//         }
//       ).format(Number(amount));

//       // if (approximate) {
//       //   try {
//       //     const currencySymbol =
//       //       formatedAmount.split(amount.toLocaleString())[0] ||
//       //       formatedAmount.split(amount.toLocaleString())[1];
//       //     const amountWithoutCurrency = Number(amount);
//       //     if (amountWithoutCurrency >= 1000000000) {
//       //       formatedAmount =
//       //         (amountWithoutCurrency / 1000000000)
//       //           .toFixed(1)
//       //           .replace(/\.0$/, "") + "B";
//       //     }
//       //     if (amountWithoutCurrency >= 1000000) {
//       //       formatedAmount =
//       //         (amountWithoutCurrency / 1000000).toFixed(1).replace(/\.0$/, "") +
//       //         "M";
//       //     } else {
//       //       formatedAmount = (amountWithoutCurrency / 1000000).replace(
//       //         /\.0$/,
//       //         ""
//       //       );
//       //     }

//       //     formatedAmount = currencySymbol + formatedAmount;
//       //   } catch (error) {}
//       // }

//       return formatedAmount;
//     }
//   } catch (error) {
//     return amount;
//   }
// };

export const _hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const _convertObjectKeysToCamelCase = o => {
  let newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = _convertObjectKeysToCamelCase(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (
          origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = _convertObjectKeysToCamelCase(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};

export const _capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const _cloneArray = array => {
  if (array) {
    return JSON.parse(JSON.stringify(array));
  }
};

export const _groupByKey = (list, key) =>
  list?.reduce(
    (hash, obj) => ({
      ...hash,
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    }),
    {}
  );

export const _convertToSelectArray = (array, name, value) => {
  try {
    array = _cloneArray(array);
    array.forEach(el => {
      el.name = el[name] || '';
      el.label = el[name] || '';
      el.value = el[value] || '';
    });
    return array;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const _changeFavicon = src => {
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = src;
  document.getElementsByTagName('head')[0].appendChild(link);
};

export const _getPageTitleName = (location, storeDetails) => {
  const pathname = location.pathname;
  if (pathname === '/') {
    return appendStoreName(storeDetails.storeName, 'Welcome');
  } else if (pathname.includes('settings/delivery')) {
    return appendStoreName(storeDetails.storeName, 'Delivery');
  } else if (pathname.includes('/order/')) {
    return appendStoreName(storeDetails.storeName, 'Order Summary');
  } else if (!pathname.split('/')[1].includes('/')) {
    return appendStoreName(
      storeDetails.storeName,
      _capitalizeFirstLetter(pathname.split('/')[1])
    );
  }
  return location.pathname;
};

function appendStoreName(storeName, pageTitle) {
  return storeName ? `${storeName} - ${pageTitle}` : `${pageTitle}`;
}

export const _pluraliseString = (string, count) => {
  return count > 1 ? `${string}s` : string;
};

export const _getIsoDateString = currentDate => {
  const date = currentDate || new Date();
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
};

export const _sortArray = (array, param, desc) => {
  return array.sort(compareValues(param, desc ? 'desc' : 'asc'));
};

function compareValues(key, order = 'asc') {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }
    if (a[key] === '' || a[key] === null || a[key] === undefined) {
      return 1;
    }
    if (b[key] === '' || b[key] === null || b[key] === undefined) {
      return -1;
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
}

export const _isOverflown = element => {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
};

export const _isViewingInApp = () => {
  if (window.matchMedia) {
    return window.matchMedia('(display-mode: standalone)').matches;
  } else return false;
};

export const _isMobile = () => {
  return window.screen.width < 768;
};

export const _getUnit = item => {
  if (!item || (!item.ProductMeasurement && !item.Unit)) {
    return '';
  }
  if (item.ProductMeasurement && item.Unit) {
    return `${item.ProductMeasurement} - ${item.Unit}`;
  }
  if (!item.ProductMeasurement && item.Unit) {
    return item.Unit;
  }
  if (item.ProductMeasurement && !item.Unit) {
    return item.ProductMeasurement;
  }
};

export const _canSubscribeForPush = () => {
  return (
    'Notification' in window &&
    navigator.serviceWorker &&
    'PushManager' in window &&
    'showNotification' in ServiceWorkerRegistration.prototype &&
    window.Notification.permission === 'default'
  );
};

export const _isModalVisible = () => {
  return !!document.querySelector('.modal-body');
};

export const _getCookie = name => {
  try {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [k, v] = el.split('=');
      cookie[k.trim()] = v;
    });
    return cookie[name];
  } catch (error) {
    return '';
  }
};

export const _deleteCookie = name => {
  document.cookie = name + '=; Max-Age=-99999999;';
};

export const _createCookie = (name, value, duration) => {
  //duration is in seconds
  try {
    const now = new Date();
    const date = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
    date.setTime(date.getTime() + duration * 1000);
    const expires = '; expires=' + date.toGMTString();
    document.cookie = name + '=' + value + expires + '; path=/';
  } catch (error) {}
};
export const _uniqueArray = (array, param, type) => {
  if (type === 'single') {
    return Array.from(new Set(array));
  } else {
    return Object.values(
      array.reduce((acc, cur) => Object.assign(acc, { [cur[param]]: cur }), {})
    );
  }
};

export const _compressImage = (file, size, name) => {
  return new Promise((resolve, reject) => {
    try {
      let updatedFile;
      const img = new Image();
      const imgUrl = window.URL.createObjectURL(file);
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const width = size || 250;
        const scaleFactor = width / img.width;
        canvas.width = width;
        canvas.height = img.height * scaleFactor;
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
        ctx.canvas.toBlob(
          blob => {
            updatedFile = new File([blob], name || 'imgupload.jpg', {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(updatedFile);
          },
          'image/jpeg',
          1
        );
      };
      img.onerror = error => {
        resolve({ error });
      };
      img.src = imgUrl;
    } catch (error) {
      console.log(error);
    }
  });
};

export const _constructImageURL = ({
  appendUrl,
  height = 200,
  width = 200,
}) => {
  if (appendUrl) {
    if (appendUrl.startsWith('http')) {
      appendUrl = appendUrl.replace('http:', 'https:');
      return appendUrl;
    }
    return `${asset_url}${appendUrl}?h=${height}&w=${width}&fit=clip&rect=center,middle,0,0&fm=webp&auto=format`;
  }
};

export const _summarizeLongText = (string, length = 25) => {
  if (string?.length > length) {
    return `${string.slice(0, length - 5)}...`;
  } else {
    return string;
  }
};

export const _getInputValue = value => {
  //remove all white space to prevent values starting with space
  const strippedValue = value ? value.toString().replace(/\s/g, '') : '';
  return !strippedValue ? '' : value;
};

export const _isIosDevice = () => {
  return (
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream
  );
};

export const _waitFor = duration => {
  return new Promise(resolve => setTimeout(resolve, duration || 0));
};

export const _capitalizeText = string => {
  return string
    ? string
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';
};

export const _nameToInitials = fullName => {
  const namesArray = fullName.trim().split(' ');
  if (namesArray.length === 1)
    return `${namesArray[0].charAt(0).toUpperCase()}`;
  else
    return `${namesArray[0].charAt(0).toUpperCase()}${namesArray[
      namesArray.length - 1
    ]
      .charAt(0)
      .toUpperCase()}`;
};

export const _validateEmail = email => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const _animateHeight = ({ active, totalLength, minHeight }) => {
  return active
    ? {
        maxHeight: totalLength > 0 ? totalLength * minHeight : minHeight,
        transition: `max-height ${totalLength > 20 ? 0.7 : 0.5}s`,
      }
    : { maxHeight: 0 };
};

export const _getOrderId = ({ OMSOrderId, OMSSubOrderID }) => {
  switch (true) {
    case OMSOrderId > 0 && OMSSubOrderID > 0:
      return `#${OMSOrderId}-${OMSSubOrderID}`;
    case OMSOrderId && OMSOrderId !== '':
      return `#${OMSOrderId}`;
    default:
      return 'Awaited';
  }
};

export const _getOrderPaymentType = order => {
  switch (order.OrderPaymentType) {
    case 1:
      return 'Pay on Delivery';
    case 2:
      return 'Paylater';
    default:
      return 'Pay on Delivery';
  }
};

export const _getLanguageData = (countryId = 1) => {
  switch (countryId) {
    case 1:
      return 'ng';
    case 2:
      return 'gh';

    default:
      return 'ng';
  }
};

export const _getCountryName = (countryId = 1) => {
  switch (countryId) {
    case 1:
      return 'Nigeria';
    case 2:
      return 'Ghana';

    default:
      return 'Nigeria';
  }
};

export const _formatDateTime = (dateTime, format = 'DD/MM/YY') => {
  if (!dateTime) return;
  return dayjs(dateTime).format(format);
};

export const _formatCurrency = value => {
  if (value >= 0) {
    return t('currency', { value });
  }
};
